import { styled } from "@mui/material";
import colors from "../../../../../theme/themeConstants";
import { useEffect, useState } from "react";
import { StyledAddCollectionButton } from "../../../../buttons/AddCollectionButton";
import { UseFormGetValues, UseFormSetValue, FieldPath } from "react-hook-form";
import { BaseButton } from "components/buttons/BaseButton";
import tick from "../../../../icons/tick.svg";
import { useKeyPress } from "../../../../../hooks/useKeyPress";
import { ISignUpFieldValues } from "../AuthSignUp";

interface IProps {
  next: () => void;
  setValue: UseFormSetValue<ISignUpFieldValues>;
  getValues: UseFormGetValues<ISignUpFieldValues>;
}

const PREFERENCES = [
  "Straight", "Gay", "Lesbian", "Trans", "Animated"
];

const DEFAULTS = PREFERENCES.map(v => v.toLowerCase());

const SignUpPreferencesStep = (props: IProps) => {
  const { next, setValue, getValues } = props;
  const _prefs = getValues().preferences;
  const [preferences, setPreferences] = useState<string[]>(_prefs ? _prefs : DEFAULTS);

  const enterPressed = useKeyPress("Enter");

  const handleNext = () => {
    if (preferences.length > 0) {
      next();
    }
  };

  const handleClick = (value: string) => {
    const newValue = value.toLowerCase();
    const newPreferences = [...preferences];
    let isExist = false;

    newPreferences.forEach((el, index) => {
      if (newValue === el) {
        isExist = true;
        newPreferences.splice(index, 1);
      }
    });

    if (!isExist) {
      newPreferences.push(newValue);
    }

    setPreferences(newPreferences);
  };

  const isSelected = (value: string) => {
    const newValue = value.toLowerCase();
    return preferences.indexOf(newValue) >= 0;
  };

  useEffect(() => {
    setValue<FieldPath<ISignUpFieldValues>>("preferences", preferences);
    // eslint-disable-next-line
  }, [preferences])

  useEffect(() => {
    if (enterPressed) {
      handleNext();
    }
    // eslint-disable-next-line
  }, [enterPressed])

  return (
    <Container>
      <Title>Select one or more preferences:</Title>
      <Wrapper>
        {PREFERENCES.map(el => (
          <Option key={el}>
            <p>{el}</p>
            <StyledAddCollectionButton
              onClick={() => handleClick(el)}
              isButtonActive={isSelected(el)}
            >
              <img src={tick} alt="selected"/>
            </StyledAddCollectionButton>
          </Option>
        ))}
      </Wrapper>
      <StyledBaseButton>
        <BaseButton onClick={handleNext} disabled={preferences.length < 1}>Next</BaseButton>
      </StyledBaseButton>
    </Container>
  );
};

export default SignUpPreferencesStep;

const Container = styled("div")({
  marginTop: "2rem",
  display: "flex",
  flexDirection: "column",
  gap: "1rem"
});

const Title = styled("p")({
  fontSize: "14px",
  color: colors.textDark,
  fontWeight: 500
});

const Wrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "20px"
});

const Option = styled("div")({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "& p": {
    fontWeight: 500,
    fontSize: "14px",
    textTransform: "capitalize !important",
  }
});

const StyledBaseButton = styled("div")({
  marginTop: "16px",
  ".tablet &, .phone &": {
    position: "absolute",
    marginTop: 0,
    bottom: "0",
    left: "0",
    width: "100%",
    padding: "16px 16px 32px",
    background: "rgba(255, 255, 255, 0.9)",
    borderRadius: "24px"
  }
});
